function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { autoUpdate, flip, offset, shift, useDismiss, useFloating, useFocus, useHover, useInteractions, useRole } from '@floating-ui/react';
import React from 'react';
import { getThemeSpacingAsNumber } from '../../../theme/foundations/spaces';
export var useTooltip = _ref => {
  var {
    placement = 'top',
    isEnabled = true
  } = _ref;
  var [isOpen, setIsOpen] = React.useState(false);
  var data = useFloating({
    placement,
    open: isOpen,
    onOpenChange: setIsOpen,
    whileElementsMounted: autoUpdate,
    middleware: [offset(getThemeSpacingAsNumber('xs')), flip(), shift({
      padding: getThemeSpacingAsNumber('m')
    })]
  });
  var {
    context
  } = data;
  var hover = useHover(context, {
    move: false,
    enabled: isEnabled
  });
  var focus = useFocus(context, {
    enabled: isEnabled
  });
  var dismiss = useDismiss(context);
  var role = useRole(context, {
    role: 'tooltip'
  });
  var interactions = useInteractions([hover, focus, dismiss, role]);
  return _objectSpread(_objectSpread({
    isOpen,
    setIsOpen
  }, interactions), data);
};
export var TooltipContext = /*#__PURE__*/React.createContext(null);
export var useTooltipContext = () => {
  var context = React.useContext(TooltipContext);

  if (context === null) {
    throw new Error('Tooltip components must be wrapped in <Tooltip />');
  }

  return context;
};
//# sourceMappingURL=tooltip.utils.js.map